
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, XCircle } from 'lucide-react';

interface GameNotFoundProps {
  onBackClick: () => void;
}

const GameNotFound = ({ onBackClick }: GameNotFoundProps) => {
  return (
    <div className="min-h-screen bg-cream-light flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-coral mx-auto mb-4" />
        <h1 className="text-3xl font-semibold mb-4">Game Not Found</h1>
        <p className="text-gray-600 mb-8">
          The game you're looking for doesn't exist or has been removed.
          Please try selecting a different game.
        </p>
        <Button 
          onClick={onBackClick} 
          className="flex items-center justify-center mx-auto"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> 
          Back to Games
        </Button>
      </div>
    </div>
  );
};

export default GameNotFound;
